import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Github from "./Github";
import Techstack from "./Techstack";
import Aboutcard from "./AboutCard";
import laptopImg from "../../Assets/about.png";
import Toolstack from "./Toolstack";

function About() {
  return (
    <Container fluid className="about-section page-shell">
      <Container className="editorial-container">
        <Row style={{ justifyContent: "center", padding: "10px" }}>
          <Col
            md={7}
            style={{
              justifyContent: "center",
              paddingTop: "30px",
              paddingBottom: "50px",
            }}
          >
            <p className="page-kicker">About the developer</p>
            <h1 className="page-title">The person behind the <em>pixels.</em></h1>
            <Aboutcard />
          </Col>
          <Col
            md={5}
            style={{ paddingTop: "120px", paddingBottom: "50px" }}
            className="about-img"
          >
            <img src={laptopImg} alt="about" className="img-fluid" />
          </Col>
        </Row>
        <h2 className="editorial-heading">What I work with</h2>

        <Techstack />

        <h2 className="editorial-heading">My everyday tools</h2>
        <Toolstack />

        <Github />
      </Container>
    </Container>
  );
}

export default About;
